module.exports = __webpack_public_path__ + "static/7-35eb5968c010e7942265feae5ab606bd.jpg";